export enum NumberSeriesViewTabIndex {
   CRM,
   FSM,
   Inventory,
};